export const PLAYBACK = {
  MAX: 1,
  SHOP: 2,
  LITE: 3,
  SOCIAL: 4,
  CTV: 5,
  MAX_O3: 6,
  TIKTOK: 7,
}

export const PLAYBACK_NAME = {
  [PLAYBACK.MAX]: 'max',
  [PLAYBACK.SHOP]: 'shop',
  [PLAYBACK.LITE]: 'lite',
  [PLAYBACK.SOCIAL]: 'social',
  [PLAYBACK.CTV]: 'ctv',
  [PLAYBACK.MAX_O3]: 'max',
  [PLAYBACK.TIKTOK]: 'tiktok',
}